import { render, staticRenderFns } from "./DrawerFooter.vue?vue&type=template&id=c86b68b2&scoped=true&"
import script from "./DrawerFooter.vue?vue&type=script&lang=js&"
export * from "./DrawerFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86b68b2",
  null
  
)

export default component.exports